import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { getJournalPost } from "../lib/api";

const JournalPost = () => {
    const { slug } = useParams();
    const [post, setPost] = useState(null);

    useEffect(() => {
        window.scrollTo({ top: 0 });
        getJournalPost(slug).then(setPost).catch(() => setPost(null));
    }, [slug]);

    if (!post) {
        return (
            <div className="max-w-3xl mx-auto px-6 lg:px-10 py-32 text-[#4A4A46]">
                Loading&hellip;
            </div>
        );
    }

    return (
        <article data-testid="journal-post-page" className="bg-[#FAF9F6]">
            <header className="max-w-3xl mx-auto px-6 lg:px-10 pt-16 pb-10">
                <Link
                    to="/journal"
                    className="text-[12px] uppercase tracking-[0.22em] alati-link"
                    data-testid="back-to-journal"
                >
                    &larr; Journal
                </Link>
                <p className="label mt-10">
                    {new Date(post.published_at).toLocaleDateString("en-AU", {
                        day: "2-digit",
                        month: "long",
                        year: "numeric",
                    })}
                </p>
                <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl mt-5 leading-tight">
                    {post.title}
                </h1>
            </header>

            <div className="max-w-5xl mx-auto px-6 lg:px-10 mb-16">
                <div className="product-image-wrap aspect-[16/9]">
                    <img
                        src={post.image}
                        alt={post.title}
                        className="w-full h-full object-cover"
                    />
                </div>
            </div>

            <div className="max-w-2xl mx-auto px-6 lg:px-10 pb-28">
                <div className="space-y-5 text-lg leading-relaxed text-[#4A4A46]">
                    {post.body.split("\n\n").map((para, i) => (
                        <p key={`${post.slug}-para-${i}`}>{para}</p>
                    ))}
                </div>
                <p className="mt-12 text-xs uppercase tracking-[0.22em] text-[#737562]">
                    Written by {post.author}
                </p>
            </div>
        </article>
    );
};

export default JournalPost;
